import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { Category } from '../../types/category';

const api = generateApiClient();

export const getCategoriesApi = async (query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`categories${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createParentCategoryApi = async (category: Category): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`categories`, category);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createChildCategoryApi = async (parentId: number, category: Category): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`categories/${parentId}`, category);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateCategoryApi = async (id: number, category: Category): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`categories/${id}`, category);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
